import { useState } from "react";
import ReactionBadges from "@/components/shared/reactions/ReactionBadges";
import ReactionButton from "@/components/shared/reactions/ReactionButton";
import {
  ReactionArg,
  ReactionLabels,
} from "@/components/shared/reactions/reactions";
import { Reaction } from "../../../../@types/activities.ts";

type Props = {
  reactions?: Reaction[] | null;
  myReaction?: string | null;
  onSelect: (emoji: string) => void;
};

// de/de_DU labels for the shared reaction primitives.
function useReactionLabels(): ReactionLabels {
  return {
    addReaction: I18n.t("js.activitystreams.reactions.add_reaction"),
    pickEmoji: I18n.t("js.activitystreams.reactions.pick_emoji"),
    reactedBy: I18n.t("js.activitystreams.reactions.reacted_by"),
    remove: I18n.t("js.activitystreams.reactions.remove"),
  };
}

// Map the server reaction shape onto the generic ReactionArg.
function mapReactions(reactions?: Reaction[] | null): ReactionArg[] {
  return (reactions || []).map((reaction) => ({
    emoji: reaction.emoji,
    member: {
      id: String(reaction.member.id),
      name: reaction.member.displayName,
      imageUrl: reaction.member.images?.["40x40@2"],
    },
  }));
}

// Aggregated reaction badges (who reacted). Rendered in the row above the
// interaction buttons, mirroring the old "… finden das interessant" list.
export function ActivityReactionBadges({
  reactions,
  onSelect,
}: Omit<Props, "myReaction">) {
  const labels = useReactionLabels();
  const myId = Preload.current_member?.id ?? "";

  return (
    <ReactionBadges
      reactions={mapReactions(reactions)}
      myId={myId}
      onToggle={onSelect}
      labels={labels}
    />
  );
}

// The "Reagieren" button (normal button + emoji quick-bar popover), placed in
// the interaction button row next to Teilen.
export function ActivityReactionButton({
  myReaction,
  onSelect,
}: Omit<Props, "reactions">) {
  const [open, setOpen] = useState(false);
  const labels = useReactionLabels();

  return (
    <ReactionButton
      currentEmoji={myReaction || undefined}
      onSelect={onSelect}
      open={open}
      onOpenChange={setOpen}
      labels={labels}
    />
  );
}
